export default __webpack_public_path__ + "static/media/image-drawer-profile.3a0d1ede.png";